var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wraper" },
    [
      _c("LeftBar"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-cntainer",
          class: { "menu-opened": _vm.getMenu }
        },
        [_c("TopBar"), _vm._v(" "), _c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }